import { ComponentProps } from "react";

const CheckCircleIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5624 7.51645C22.8704 6.31698 19.8629 6.01983 16.9882 6.66932C14.1136 7.31881 11.5259 8.88014 9.61106 11.1204C7.69627 13.3608 6.55695 16.16 6.36304 19.1007C6.16913 22.0415 6.93101 24.9661 8.53506 27.4384C10.1391 29.9108 12.4994 31.7984 15.2639 32.8197C18.0283 33.841 21.0489 33.9414 23.8751 33.1058C26.7012 32.2702 29.1816 30.5434 30.9462 28.1829C32.7108 25.8225 33.6651 22.9549 33.6667 20.0078V18.6285C33.6667 17.8922 34.2637 17.2952 35.0001 17.2952C35.7365 17.2952 36.3334 17.8922 36.3334 18.6285V20.0085C36.3314 23.5307 35.1909 26.9586 33.082 29.7796C30.9731 32.6006 28.0088 34.6643 24.6312 35.663C21.2535 36.6617 17.6436 36.5417 14.3397 35.3211C11.0358 34.1005 8.21502 31.8446 6.29798 28.8898C4.38095 25.9351 3.47041 22.4398 3.70215 18.9253C3.9339 15.4108 5.29552 12.0653 7.58394 9.38786C9.87235 6.71041 12.965 4.84443 16.4005 4.06821C19.8361 3.29199 23.4305 3.64713 26.6477 5.08064C27.3204 5.38035 27.6227 6.16858 27.323 6.84121C27.0233 7.51384 26.235 7.81616 25.5624 7.51645Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.9424 7.06535C36.4634 7.58579 36.4638 8.43001 35.9434 8.95096L20.9434 23.966C20.6934 24.2162 20.3542 24.3569 20.0004 24.357C19.6467 24.357 19.3074 24.2166 19.0573 23.9664L14.5573 19.4664C14.0366 18.9457 14.0366 18.1015 14.5573 17.5808C15.078 17.0601 15.9222 17.0601 16.4429 17.5808L19.9996 21.1375L34.0568 7.06629C34.5772 6.54533 35.4215 6.54491 35.9424 7.06535Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CheckCircleIcon;
